<div mat-dialog-close class="close-button" (click)="close()">
  <mat-icon>close</mat-icon>
</div>
<div mat-dialog-header>
  <h1 class="mb-0"> {{ data.label || 'Launch to Annuity Wizard' }} </h1>
  <p>
    Drag and drop annuities to specify if they will be used in a
    replacement/1035 exchange (one or more), or subsequent deposit (limit to
    one).
  </p>
</div>

<div mat-dialog-content class="dialog-content">
  <div class="list-container">
    <h4>Selected Annuities</h4>

    <div
      #selectedList="cdkDropList"
      cdkDropList
      class="list"
      [cdkDropListData]="selected"
      [cdkDropListConnectedTo]="[exchangeList, depositList]"
      (cdkDropListDropped)="drop($event)"
    >
      @for (item of selected; track item.ID) {
        <div class="list-item-box" cdkDrag>
          <span class="list-item-name">
            <mat-icon class="me-1">drag_handle</mat-icon>
            {{ item.Name }}
          </span>
          <button
            mat-icon-button
            color="warn"
            matTooltip="Remove Annuity"
            (click)="removeAnnuity(item, 'selected')"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      }
    </div>
  </div>

  <div class="list-container">
    <h4>Replacement/1035 Exchange</h4>

    <div
      #exchangeList="cdkDropList"
      cdkDropList
      class="list"
      [cdkDropListData]="exchange"
      [cdkDropListConnectedTo]="[selectedList, depositList]"
      (cdkDropListDropped)="drop($event)"
    >
      @for (item of exchange; track item.ID) {
        <div class="list-item-box" cdkDrag>
          <span class="list-item-name">
            <mat-icon class="me-1">drag_handle</mat-icon>
            {{ item.Name }}
          </span>
          <button
            mat-icon-button
            color="warn"
            matTooltip="Remove Annuity"
            (click)="removeAnnuity(item, 'exchange')"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      }
    </div>
  </div>

  <div class="list-container">
    <h4>Subsequent Deposit</h4>

    <div
      #depositList="cdkDropList"
      cdkDropList
      class="list deposit-list"
      [cdkDropListData]="deposit"
      [cdkDropListConnectedTo]="[selectedList, exchangeList]"
      (cdkDropListDropped)="drop($event)"
    >
      @for (item of deposit; track item.ID) {
        <div class="list-item-box" cdkDrag>
          <span class="list-item-name">
            <mat-icon class="me-1">drag_handle</mat-icon>
            {{ item.Name }}
          </span>
          <button
            mat-icon-button
            color="warn"
            matTooltip="Remove Annuity"
            (click)="removeAnnuity(item, 'deposit')"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      }
    </div>
  </div>
</div>

<div mat-dialog-actions>
  <button mat-raised-button class="me-2" (click)="close()">Cancel</button>
  <button
    mat-raised-button
    color="accent"
    [disabled]="selected && selected.length > 0"
    (click)="saveData()"
  >
    Launch
  </button>
</div>

<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop: false }" />
